import { Step } from '../../components/Step';
import { Box } from '@mui/material';
import { Checkboxes } from 'mui-rff';
import { useTranslation } from 'react-i18next';
import PaidIcon from '@mui/icons-material/Paid';

export const Step4 = () => {
  const { t } = useTranslation('settings');

  return (
    <Step title={`${t('integrations.step')} 4`} subtitle={t('integrations.if you also want to record')} Icon={PaidIcon}>
      <Box mt={-2} mb={4}>
        <Checkboxes name="recordTransactions" data={{ label: t('integrations.record transactions'), value: false }} />
      </Box>
    </Step>
  );
};
